module.exports = __webpack_public_path__ + "static/media/arrowLeft.87fac80e.svg";